/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var gettext = require('mag-gettext').gettext;

module.exports = [
    {value: 0xFFFFFF, name: gettext('White')},
    {value: 0x000000, name: gettext('Black')},
    {value: 0xFF0000, name: gettext('Red')},
    {value: 0x0000FF, name: gettext('Blue')},
    {value: 0x00FF00, name: gettext('Green')},
    {value: 0xFFFF00, name: gettext('Yellow')},
    {value: 0x00FFFF, name: gettext('Cyan')},
    {value: 0xFF00FF, name: gettext('Magenta')},
    {value: 0xC0C0C0, name: gettext('Silver')},
    {value: 0x808080, name: gettext('Gray')},
    {value: 0x800000, name: gettext('Maroon')},
    {value: 0x808000, name: gettext('Olive')},
    {value: 0x800080, name: gettext('Purple')},
    {value: 0x008080, name: gettext('Teal')},
    {value: 0x000080, name: gettext('Navy')}
];
